<div class="categoria-macchina">
    <div *ngIf="categorie.length>0"  class="categorie">
        <!--h4>Categorie</h4-->
        <div class="lista-categorie">
            <div class="card-categoria" *ngFor="let m of categorie">
                 <mat-card>
                     <a (click)="onSelect(m)"><div class="imgcat bgfix" [ngStyle]="{'background-image': 'url(' + m.img + ')'}"></div></a>
                    <mat-card-footer mdx-paing-fg="accent">
                        <button title="{{m.nome}}" mat-raised-button color="primary" (click)="onSelect(m)">{{ m.nome|truncate:40:"..."}}</button>
                    </mat-card-footer>
                </mat-card>
            </div>
        </div>
    </div>
</div> 


// WEBPACK FOOTER //
// ./src/app/tws-categoria/tws-categoria.component.html